import ToggleRow from 'app/components/ToggleRow/ToggleRow';
import { EntityTypes } from 'constants/entities';
import { useSave } from 'core/hooks/useSave';
import React from 'react';
import { CourseNodeStatus, ICourseNodeDAO, IModuleCourseNode } from 'types/domain/course';

interface CourseNodeStatusProps {
  className?: string;
  courseNode: ICourseNodeDAO | IModuleCourseNode;
  isDefault?: boolean;
}

const CourseNodeStatusToggle: React.FC<CourseNodeStatusProps> = ({ className, courseNode, isDefault }) => {
  const save = useSave(EntityTypes.COURSE_NODE);
  return (
    <ToggleRow
      className={className}
      selected={courseNode?.status}
      onSelectionChange={status => {
        if (!courseNode?.id) return;
        save({ id: courseNode.id, status });
      }}
      options={[
        ...(!isDefault ? [{ label: 'Default', value: CourseNodeStatus.INHERIT }] : []),
        { label: 'Logged in', value: CourseNodeStatus.PRIVATE },
        { label: 'Anonymous', value: CourseNodeStatus.PUBLIC },
      ]}
    />
  );
};

export default CourseNodeStatusToggle;
